<div class="modal-header" appCustomAutofocus>
    <h3>Decline All Coverages</h3>
</div>
<div class="modal-body">
    <form #declineForm="ngForm">
        <p>Are you sure you want to decline coverage?</p>
        <br />
        <div class="row">
            <div class="col-lg-4" *ngIf="showDeclineType">
                <ng-select [ngClass]="{'is-invalid' : formData.selectedDecline == null}"
                    [(ngModel)]="formData.selectedDecline" [searchable]="false" [clearable]="false"
                    [required]="formData.selectedDecline == null" name="option" dropdownPosition="bottom"
                    [items]="declineList" bindLabel="DisplayValue" bindValue="DisplayValue"
                    placeholder="Select a reason">
                </ng-select>
            </div>
            <div class="col-lg-8" *ngIf="showDeclineType">
                <input type="text" class="form-control"
                    placeholder="Please describe your reason for declining coverage here." [(ngModel)]="formData.Notes"
                    [required]="formData.Notes == null || formData.Notes == ''" style="margin-bottom:15px;"
                    name="declineReason" />
            </div>

            <div class="col-lg-12" *ngIf="!showDeclineType">
                <input type="text" class="form-control"
                    placeholder="Please describe your reason for declining coverage here." [(ngModel)]="formData.Notes"
                    [required]="formData.Notes == null || formData.Notes == ''" style="margin-bottom:15px;" name="declineReason" />
            </div>
        </div>
        <quill-view [content]="rejectionText"></quill-view>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="declineClicked()"
        [disabled]="declineForm.form.invalid">Decline All</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>